import { PageHeader, Spin, message } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import KanbanTablero from "../../../Components/KanbanTablero";
import ButtonItem from "../../../Components/ButtonItem";
import AgregarLoteAProcesos from "./AgregarLoteAProcesos/AgregarLoteAProcesos";
import VerLote from "../Lotes/VerLote/VerLote";
import EditarLote from "../Lotes/EditarLote/EditarLote";
import VerAgrupacion from "../Agrupaciones/VerAgrupacion/VerAgrupacion";
import EditarAgrupacion from "../Agrupaciones/EditarAgrupacion/EditarAgrupacion";
import * as XLSX from 'xlsx'
import ModalListaEtapa from "./ModalListaEtapa/ModalListaEtapa";
import ModalAsignar from "../DashboardTaxidermia/ModalAsignar";
import moment from "moment";

class DashboardProcesos extends Component {
  state = {
    todasetapas: [],
    loading: false,
    valor: 1,
    modalAgregarLoteAProcesos: false,
    etapaId: null,
    modalEdicionLote: false,
    modalEdicionLoteId: null,
    modalEdicionLoteEdiciones: null,
    modalEdicionLoteEtapaId: null,
    etapasAntesDeMovimiento: null,
    modalEdicionAgrupacion: false,
    modalEdicionAgrupacionId: null,
    modalEdicionAgrupacionEdiciones: null,
    modalEdicionAgrupacionEtapaId: null,
    modalVerAgrupacion: false,
    modalVerAgrupacionId: null,
    asignarDespuesDeMover: null,
  };

  // Taxidermia: si la pieza entro a una etapa con control por persona, se ofrece asignarla
  // (opcional; si se cierra, queda en "Por asignar" del tablero por persona).
  ofrecerAsignar = (agrupacionIds, etapaId) => {
    const etapa = this.state.todasetapas.find((e) => e._id === etapaId);
    if (!etapa || etapa.controlPorPersona !== true || !agrupacionIds?.length) return;
    const actividades = this.state.todasetapas.flatMap((e) => e.actividades || []);
    const descripcion = agrupacionIds
      .map((id) => actividades.find((a) => String(a._id) === String(id))?.nombre)
      .filter(Boolean)
      .join(", ");
    this.setState({
      asignarDespuesDeMover: { agrupacionIds, descripcion, etapa: { _id: etapa._id, nombre: etapa.nombre } },
    });
  };

  componentDidMount() {
    this.consultarEtapas(this.state.valor);
  }

  consultarEtapas = (valor) => {
    this.setState({ loading: true });

    axios
      .post(
        "procesos/selectDashboard",
        { empresaId: this.props.empresaId, valor },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });

        if (res.data.success === 2) {
          if (res.data.etapas?.length > 0) {
            // Clonamos etapas y agregamos una actividad de prueba a la primera
            const etapasConActividades = res.data.etapas

            this.setState({ todasetapas: etapasConActividades });

          } else {
            this.setState({ todasetapas: [] });
          }
        } else {
          this.setState({ todasetapas: [] });
        }
      })

      .catch((error) => {
        this.setState({ loading: false });
        console.error("Error al consultar etapas:", error);
        message.error("Error al cargar las etapas");
      });
  };

  // handleEstadoChange = (etapaId, nuevoEstado) => {
  //   console.log("Cambiando estado de etapa:", etapaId, "a nuevo estado:", nuevoEstado);
  //   const nuevasEtapas = this.state.todasetapas.map((etapa) =>
  //     etapa._id === etapaId ? { ...etapa, estadoMock: nuevoEstado } : etapa
  //   );
  //   this.setState({ todasetapas: nuevasEtapas });

  //   // Aquí puedes llamar al backend si lo deseas:
  //   // axios.put("etapas/actualizarEstado", { etapaId, nuevoEstado, empresaId: this.props.empresaId }, { headers: this.props.headersToken })
  //   //   .then(() => message.success("Estado actualizado"))
  //   //   .catch(() => message.error("Error al actualizar estado"));
  // };

  handleActividadMove = (agrupacionId, nuevaEtapaId) => {
    const etapaAnterior = this.state.todasetapas.find((e) =>
      e.actividades?.some((a) => a._id === agrupacionId)
    );
    if (!etapaAnterior) {
      console.error("Actividad no encontrada en ninguna etapa");
      message.error("Actividad no encontrada en ninguna etapa");
      return;
    }
    if (etapaAnterior._id === nuevaEtapaId) return

    const etapasAnteriores = [...this.state.todasetapas];

    const nuevasEtapas = etapasAnteriores.map((etapa) => {
      const nuevaLista = etapa.actividades?.filter((a) => a._id !== agrupacionId) || [];
      return { ...etapa, actividades: nuevaLista };
    });

    const actividadMovida = this.state.todasetapas
      .flatMap((e) => e.actividades || [])
      .find((a) => a._id === agrupacionId);

    const indexDestino = nuevasEtapas.findIndex(e => e._id === nuevaEtapaId);
    if (actividadMovida && indexDestino !== -1) {
      nuevasEtapas[indexDestino].actividades.push(actividadMovida);
    }

    this.setState({ loading: true });

    this.setState({ todasetapas: nuevasEtapas });

    axios.post("procesos/moverAgrupacionAEtapa", {
      agrupacionId,
      nuevaEtapaId,
      empresaId: this.props.empresaId,
    }, {
      headers: this.props.headersToken,
    }).then((res) => {
      if (res.data.success === 2) {
        if (res.data.editarAlEntrar) {
          message.info("Edite para continuar")
          this.setState({
            modalEdicionAgrupacion: true,
            modalEdicionAgrupacionId: agrupacionId,
            modalEdicionAgrupacionEdiciones: res.data,
            modalEdicionAgrupacionEtapaId: nuevaEtapaId,
            etapasAntesDeMovimiento: etapasAnteriores
          });
        } else {
          message.success("Actividad movida correctamente");
          this.ofrecerAsignar([agrupacionId], nuevaEtapaId);
        }
      } else {
        this.setState({ todasetapas: etapasAnteriores });
        message.warning(res.data.message || "No se pudo mover la actividad");
      }
      this.setState({ loading: false })
    }).catch((error) => {
      this.setState({ todasetapas: etapasAnteriores, loading: false });
      console.error("Error al mover la actividad:", error);
      message.error("Error al mover la actividad");
    });
  };

  handleActividadMoveMultiple = (agrupacionIds, nuevaEtapaId) => {
    this.setState({ loading: true });

    axios.post("procesos/moverVariasAgrupacionesAEtapa", {
      agrupacionesIds: agrupacionIds,
      nuevaEtapaId,
      empresaId: this.props.empresaId,
    }, {
      headers: this.props.headersToken,
    }).then((res) => {
      if (res.data.success === 2) {
        const { movidas = [], noValidas = [], noEncontradas = [] } = res.data;
        const noMovidas = noValidas.length + noEncontradas.length;

        if (movidas.length && !noMovidas) {
          message.success(`${movidas.length} actividad(es) movida(s) correctamente`);
        } else if (movidas.length) {
          message.warning(`${movidas.length} movida(s), ${noMovidas} no se pudieron mover (transición no válida)`);
        } else {
          message.warning("No se pudo mover ninguna actividad (transición no válida)");
        }

        this.ofrecerAsignar(movidas, nuevaEtapaId);
        this.consultarEtapas(this.state.valor);
      } else {
        this.setState({ loading: false });
        message.warning(res.data.message || "No se pudieron mover las actividades");
      }
    }).catch((error) => {
      this.setState({ loading: false });
      console.error("Error al mover las actividades:", error);
      message.error("Error al mover las actividades");
    });
  };

  handleActividadEliminar = (agrupacionId) => {
    const etapasAnteriores = [...this.state.todasetapas];

    const nuevasEtapas = etapasAnteriores.map((etapa) => ({
      ...etapa,
      actividades: etapa.actividades?.filter((a) => a._id !== agrupacionId) || [],
    }));

    this.setState({ todasetapas: nuevasEtapas, loading: true });

    axios.post("procesos/quitarAgrupacionDeEtapa", {
      agrupacionId,
      empresaId: this.props.empresaId,
    }, {
      headers: this.props.headersToken,
    }).then((res) => {
      this.setState({ loading: false });
      if (res.data.success === 2) {
        message.success("Agrupación quitada del tablero correctamente");
      } else {
        this.setState({ todasetapas: etapasAnteriores });
        message.warning(res.data.message || "No se pudo quitar la agrupación");
      }
    }).catch((error) => {
      this.setState({ todasetapas: etapasAnteriores, loading: false });
      console.error("Error al quitar la agrupación:", error);
      message.error("Error al quitar la agrupación");
    });
  };

  handleActividadClick = (actividadId) => {
    // Aquí puedes abrir un modal o hacer algo con la actividad clickeada
    // Por ejemplo, podrías abrir un modal para ver los detalles de la actividad
    // this.verLote(actividadId);
    this.verAgrupacion(actividadId);
  }

  cerrarAgregarLoteAProcesos() {
    this.consultarEtapas(this.state.valor);
    this.setState({ modalAgregarLoteAProcesos: false });
  }

  verLote(id) {
    this.setState({
      modalVerLote: true,
      modalVerLoteId: id,
    })
  }

  cerrarVerLote() {
    this.setState({
      modalVerLote: false,
      modalVerLoteId: null
    })
  }

  verAgrupacion(id) {
    this.setState({
      modalVerAgrupacion: true,
      modalVerAgrupacionId: id,
    })
  }

  cerrarVerAgrupacion() {
    this.setState({
      modalVerAgrupacion: false,
      modalVerAgrupacionId: null
    })
  }

  cerrarEditarAgrupacion(e) {
    const agrupacionMovida = this.state.modalEdicionAgrupacionId;
    const etapaDestino = this.state.modalEdicionAgrupacionEtapaId;
    if (e?.cerrarModificado) {
      axios.post("procesos/moverAgrupacionAEtapaConRestricciones", {
        agrupacionId: this.state.modalEdicionAgrupacionId,
        nuevaEtapaId: this.state.modalEdicionAgrupacionEtapaId,
        empresaId: this.props.empresaId,
      }, {
        headers: this.props.headersToken,
      }).then((res) => {
        if (res.data.success === 2) {
          message.success("Actividad movida correctamente");
          this.setState({
            modalEdicionAgrupacion: false,
            modalEdicionAgrupacionId: null,
            modalEdicionAgrupacionEdiciones: null,
            etapasAntesDeMovimiento: null,
            modalEdicionAgrupacionEtapaId: null,
          });
          this.ofrecerAsignar([agrupacionMovida], etapaDestino);
        } else {
          this.setState({
            todasetapas: this.state.etapasAntesDeMovimiento,
            modalEdicionAgrupacion: false,
            modalEdicionAgrupacionId: null,
            modalEdicionAgrupacionEdiciones: null,
            etapasAntesDeMovimiento: null,
            modalEdicionAgrupacionEtapaId: null,
          });
          message.warning(res.data.message || "No se pudo mover la actividad");
        }
        this.setState({ loading: false })
      }).catch((error) => {
        this.setState({
          todasetapas: this.state.etapasAntesDeMovimiento,
          modalEdicionAgrupacion: false,
          modalEdicionAgrupacionId: null,
          modalEdicionAgrupacionEdiciones: null,
          etapasAntesDeMovimiento: null,
          modalEdicionAgrupacionEtapaId: null,
          loading: false,
        });
        console.error("Error al mover la actividad:", error);
        message.error("Error al mover la actividad");
      });
    } else {
      this.setState({
        modalEdicionAgrupacion: false,
        modalEdicionAgrupacionId: null,
        modalEdicionAgrupacionEdiciones: null,
        todasetapas: this.state.etapasAntesDeMovimiento,
        etapasAntesDeMovimiento: null,
        modalEdicionAgrupacionEtapaId: null,
        loading: false
      });
    }
  }

  handleEtapaVer = (etapaId, tareas, etapa) => {
    this.setState({ loading: true, modalListaEtapa: true, modalListaEtapaData: etapa });
  }

  handleEtapaExcel = (etapaId, tareas, etapa) => {
    if(tareas.length === 0) {
      message.info("No hay tareas para exportar en esta etapa");
      this.setState({ loading: false });
      return;
    }

    this.setState({ loading: true });


    // Preparar datos de tareas
    const datosTareas = tareas.map(tarea => ({
      "Numero": tarea.numero,
      "Nombre": tarea.insumoNombre || "N/A",
      "Descripción": tarea.descripcion,
      "Estado": tarea.textoTag,
      "Cantidad": tarea.cantidad,
      "Cliente": tarea.clienteNombre || "N/A",
    }));

    // Crear la hoja de Excel
    const ws = XLSX.utils.json_to_sheet(datosTareas);

    // Aplicar estilos al encabezado
    const encabezados = Object.keys(datosTareas[0]);

    ws["!cols"] = encabezados.map(() => ({ wch: 20 })); // Ajustar ancho de columnas

    // Crear el libro de Excel
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, etapa.nombre || "Etapa");

    // Exportar archivo Excel
    XLSX.writeFile(wb, `${(etapa.nombre || "Etapa") + "_" + moment().locale("es").format("L")}.xlsx`);
    this.setState({ loading: false });
  }

  cerrarListaEtapa = () => {
    this.setState({ modalListaEtapa: false, modalListaEtapaData: null, loading: false });
  }

  moverLoteEtapa = (loteId, nuevaEtapaId) => {
    this.setState({ loading: false, modalListaEtapa: false, modalListaEtapaData: null });
    this.handleActividadMove(loteId, nuevaEtapaId);
  }

  render() {
    const { todasetapas } = this.state;

    const botonAgregarLote = (
      <ButtonItem type="primary"  className="botonAgregar" onClick={() => this.setState({ modalAgregarLoteAProcesos: true })}>
        Agregar Lote
      </ButtonItem>
    );

    return (
      <>
        {this.props.embebido ? (
          // Dentro del Dashboard de Taxidermia (pestaña "Por etapa"): el titulo lo pone el contenedor.
          <div style={{ display: "flex", justifyContent: "flex-end" }}>{botonAgregarLote}</div>
        ) : (
          <PageHeader
            title="Dashboard de Etapas"
            style={{
              border: "1px solid #ebedf0",
              backgroundColor: "white",
              marginBottom: 10,
            }}
            extra={botonAgregarLote}
          />
        )}

        <Spin spinning={this.state.loading}>

          <KanbanTablero
            etapas={todasetapas}
            onActividadMove={this.handleActividadMove}
            onActividadMoveMultiple={this.handleActividadMoveMultiple}
            onActividadClick={this.handleActividadClick}
            onActividadEliminar={this.handleActividadEliminar}
            onEtapaVer={this.handleEtapaVer}
            onEtapaExcel={this.handleEtapaExcel}
            disableExcel
          />
          <AgregarLoteAProcesos
            visible={this.state.modalAgregarLoteAProcesos}
            cerrarAgregarLoteAProcesos={this.cerrarAgregarLoteAProcesos.bind(this)}
            headersToken={this.props.headersToken}
            empresaId={this.props.empresaId}
          />
        </Spin>
        <VerLote
          visible={this.state.modalVerLote}
          cerrarVerLote={this.cerrarVerLote.bind(this)}
          loteId={this.state.modalVerLoteId}
          headersToken={this.props.headersToken}
          empresaId={this.props.empresaId}
        />
        <EditarLote
          visible={this.state.modalEdicionLote}
          cerrarEditarLote={(e) => this.cerrarEditarLote(e)}
          loteId={this.state.modalEdicionLoteId}
          ediciones={this.state.modalEdicionLoteEdiciones}
          cancelarEdiciones
          headersToken={this.props.headersToken}
          empresaId={this.props.empresaId}
        />
        <VerAgrupacion
          visible={this.state.modalVerAgrupacion}
          cerrarVerAgrupacion={this.cerrarVerAgrupacion.bind(this)}
          agrupacionId={this.state.modalVerAgrupacionId}
          headersToken={this.props.headersToken}
          empresaId={this.props.empresaId}
        />
        <EditarAgrupacion
          visible={this.state.modalEdicionAgrupacion}
          cerrarEditarAgrupacion={(e) => this.cerrarEditarAgrupacion(e)}
          agrupacionId={this.state.modalEdicionAgrupacionId}
          ediciones={this.state.modalEdicionAgrupacionEdiciones}
          cancelarEdiciones
          headersToken={this.props.headersToken}
          empresaId={this.props.empresaId}
        />
        <ModalListaEtapa
          visible={this.state.modalListaEtapa}
          cerrarListaEtapa={this.cerrarListaEtapa}
          moverLoteEtapa={this.moverLoteEtapa}
          etapa={this.state.modalListaEtapaData}
          headersToken={this.props.headersToken}
          empresaId={this.props.empresaId}
        />
        <ModalAsignar
          visible={!!this.state.asignarDespuesDeMover}
          agrupacionIds={this.state.asignarDespuesDeMover?.agrupacionIds || []}
          descripcion={this.state.asignarDespuesDeMover?.descripcion}
          etapa={this.state.asignarDespuesDeMover?.etapa}
          onCerrar={() => this.setState({ asignarDespuesDeMover: null })}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
  taxidermia: state.empresa.taxidermia,
});

export default connect(mapStateToProps)(DashboardProcesos);
